import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker';
import logout from './../../Global/logout';

export default async function DeleteUser(   
   clientUuid = "",
   userUuid = ""
) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    let query = "/" + userUuid + "?clientUuid=" + clientUuid
    return await resolve(
        axios( 'provider/client/user' + query, {
            method: 'delete',
            headers: { 'Authorization' : unHashedJwt.data}           
        }).then(res => res.data)
        .catch(error => error.response.data),
        "Admin"
        );
}